import type {
  InvoicingFeatureName,
  InvoicingFeatures,
} from '../models/invoicing';

interface FeatureGatedLink {
  feature?: InvoicingFeatureName;
}

interface FeatureGatedGroup<S extends FeatureGatedLink>
  extends FeatureGatedLink {
  subList?: S[];
}

const isEnabled = (
  link: FeatureGatedLink,
  features: InvoicingFeatures,
): boolean => !link.feature || features[link.feature];

/**
 * Toglie dalla sidebar le voci legate a funzioni spente dal provider di
 * fatturazione (es. Autofatture e Credenziali Gestify con Previxio) e i gruppi
 * rimasti vuoti. Senza configurazione caricata restituisce le voci invariate.
 */
export const filterByInvoicingFeatures = <
  S extends FeatureGatedLink,
  T extends FeatureGatedGroup<S>,
>(
  links: T[],
  features: InvoicingFeatures | undefined,
): T[] => {
  if (!features) return links;
  return links
    .filter((link) => isEnabled(link, features))
    .map((link) =>
      link.subList
        ? {
            ...link,
            subList: link.subList.filter((sub) => isEnabled(sub, features)),
          }
        : link,
    )
    .filter((link) => !link.subList || link.subList.length > 0);
};
